/* Modern Cooking — Meet-the-maker spotlight (Makers meganav panel)
 *
 * Pairs with snippets/meganav-makers.liquid. The Liquid emits ONE hidden
 * <div data-spotlight-card data-maker-handle="..."> per non-retired maker
 * inside [data-meganav-spotlight]. This script picks one and unhides it.
 *
 * Selection rule (matches 00-mockup-spec.md §3.3):
 *   - Sticky per visitor for 7 days via localStorage key `mc_featured_maker`.
 *   - On expiry / first visit: pick uniformly at random from the pool,
 *     EXCLUDING the previously-saved handle when one exists (avoid an
 *     immediate repeat).
 *   - Wrapped in try/catch so private mode / quota errors fall back to a
 *     non-persisted random pick.
 *
 * The mockup's "↻ preview another" demo control is intentionally absent
 * here; this script exposes no UI hook to force a re-pick.
 */
(function () {
  if (window.__mcMakerSpotlightInit) return;
  window.__mcMakerSpotlightInit = true;

  var STORAGE_KEY = 'mc_featured_maker';
  var EXPIRY_MS = 7 * 24 * 60 * 60 * 1000;

  function pickSpotlight() {
    var container = document.querySelector('[data-meganav-spotlight]');
    if (!container) return;
    var cards = Array.prototype.slice.call(container.querySelectorAll('[data-spotlight-card]'));
    if (!cards.length) return;

    var pool = cards.map(function (c) { return c.dataset.makerHandle; });
    var now = Date.now();
    var stored = null;
    try {
      stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      stored = null;
    }

    var pick;
    if (stored && stored.expires > now && pool.indexOf(stored.maker) !== -1) {
      pick = stored.maker;
    } else {
      var avoid = stored ? stored.maker : null;
      var candidates = avoid ? pool.filter(function (h) { return h !== avoid; }) : pool;
      if (!candidates.length) candidates = pool;
      pick = candidates[Math.floor(Math.random() * candidates.length)];
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ maker: pick, expires: now + EXPIRY_MS }));
      } catch (e) {
        /* localStorage unavailable; just don't persist. */
      }
    }

    cards.forEach(function (c) {
      if (c.dataset.makerHandle === pick) {
        c.hidden = false;
        c.removeAttribute('hidden');
      } else {
        c.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pickSpotlight);
  } else {
    pickSpotlight();
  }
})();
